module.exports = __webpack_public_path__ + "img/mobile-dl-cn.5fa83df0.png";